// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608210427/js/" + chunkId + "." + {"44":"52cd0a97","225":"180ed485","481":"d360344a","486":"31533b98","770":"2cf69828"}[chunkId] + ".0.23412134593055678.chunk.js";
};